import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {Image, Row, Col} from 'react-bootstrap';

export default function OralSupplierList(props) {
  return (
    <li key={props.id} className="content-list-element">
      <Link to={`./${props.id}`} style={{display: 'block'}}>
        <Row style={{height: '100%'}}>
          <Col xs={3} style={{maxHeight: '100%', maxWidth: '100%'}}>
            <Image src={props.image} alt="" />
          </Col>
          <Col
            xs={9}
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              height: '100%',
            }}
          >
            <h4 style={{color: '#474747', margin: '0'}}>{props.title}</h4>
          </Col>
        </Row>
      </Link>
    </li>
  );
}

OralSupplierList.propTypes = {
  id: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string,
};
